import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const usePostIntegrationApiKeyAuthMutation = ({
	provider,
	onError,
	onSuccess,
	impersonationContext,
}: {
	provider: Api.IntegrationProvider;
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: () => void;
	impersonationContext?: Api.IImpersonationContext;
}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({ apiKey }: { apiKey: string }) => {
			return userSession.webServiceHelper.callAsync(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `integrations/${provider}/auth`,
				}),
				'POST',
				{ apiKey }
			);
		},
		onError,
		onSuccess,
	});
};
